import { Button, FormControlLabel, FormGroup, Switch, Typography } from '@mui/material';
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material/node';
import React from "react";
import {useState} from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export default function ProjectVisibilityManagement(props) {
  const [isSharingEnabled, setIsSharingEnabled] = useState(props.projectData?.ispublic);
  const [isCommentingEnabled, setIsCommentingEnabled] = useState(props.projectData?.allowcomments);
  const [projectUrl, setProjectUrl] = useState(window.location.href.replace("project", "p"))
  
  const handleShareState = (e) => {
    setIsSharingEnabled(!isSharingEnabled);
    props.handleChange({target: {
      name: "ispublic",
      value: !isSharingEnabled
    }});
  };

  const handleCommentsState = (e) => {
    setIsCommentingEnabled(!isCommentingEnabled);
    props.handleChange({target: {
      name: "allowcomments",
      value: !isCommentingEnabled
    }});
  };

  const handleCopy = async () => {
    await navigator.clipboard.writeText(projectUrl);
  };

  return (
    <div>
      <Typography variant="caption">
        Share your project with public.
      </Typography>
      <FormGroup>
        <FormControlLabel control={<Switch onChange={handleShareState} checked={isSharingEnabled} />} label="Share" />
        {/* <TextField id="project-share-url" label="Project URL" size="small" margin="dense" sx={{ width: "100%" }} value={projectUrl} readOnly disabled={!isSharingEnabled}/> */}
        {isSharingEnabled && <FormControl sx={{ width: '100%', my: 2 }} variant="outlined">
          <InputLabel >Project URL</InputLabel>
          <OutlinedInput 
            size="small"
            id="outlined-adornment-password"
            type="text"
            sx={{ width: "100%" }}
            value={projectUrl}
            readOnly
            disabled
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleCopy}
                  edge="end"
                >
                 <ContentCopyIcon></ContentCopyIcon>
                </IconButton>
              </InputAdornment>
            }
            label="Project URL"
          />
        </FormControl>}
        <Typography variant="caption">Comments are visible for everyone</Typography>
        <FormControlLabel control={<Switch disabled={!isSharingEnabled} onChange={handleCommentsState} checked={isCommentingEnabled}  />} label="Allow comments" />
        <Button fullWidth sx={{ mt: "15px" }} >Show Comments</Button>
        {/* <FormControlLabel control={<Switch />} label="Allow messages (Only for owner)" /> */}
      </FormGroup>
    </div>
  );
}